document.addEventListener("DOMContentLoaded", () => {
  const stickyBar = document.getElementById("StickyATC");
  const stickyPrice = document.getElementById("StickyPrice");
  const stickyButton = document.getElementById("StickyAddToCart");

  const originalButton = document.querySelector(
    '.product-form__submit[name="add"]'
  );

  const productButtons = document.querySelector(".product-form__buttons");

  if (!stickyBar || !originalButton || !productButtons) return;

  // Show/Hide sticky bar
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove("show");
      } else {
        stickyBar.classList.add("show");
      }
    },
    {
      threshold: 0,
    }
  );

  observer.observe(productButtons);

  // Sticky Add to Cart
  stickyButton.addEventListener("click", () => {
    originalButton.click();
  });

  // Update price when variant changes
  document.addEventListener("change", (event) => {
    const variantInput = document.querySelector(
      'input[name="id"].product-variant-id'
    );

    if (!variantInput) return;

    const variantId = Number(variantInput.value);

    const productData = JSON.parse(
      document.getElementById("StickyProductJson").textContent
    );

    const variant = productData.variants.find(v => v.id === variantId);

    if (!variant) return;

    stickyPrice.innerHTML = Shopify.formatMoney(
      variant.price,
      window.shopifyMoneyFormat || "{{ shop.money_format }}"
    );

    if (variant.available) {
      stickyButton.disabled = false;
      stickyButton.textContent = "Add to cart";
    } else {
      stickyButton.disabled = true;
      stickyButton.textContent = "Sold out";
    }
  });
});

